/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ApiInformationV1Dto = {
  /**
   * The version of the API
   */
  version: string;
  /**
   * The Backend URL of the API
   */
  backendUrl: string;
  /**
   * The Document Storage API URI
   */
  documentStorageApiUri: string;
  /**
   * The Frontend URL
   */
  frontendUrl: string;
  /**
   * The mail principal name used by the API
   */
  mailPrincipalName: string;
  /**
   * The application environment
   */
  zelosEnvironment: ApiInformationV1Dto.zelosEnvironment;
};
export namespace ApiInformationV1Dto {
  /**
   * The application environment
   */
  export enum zelosEnvironment {
    LOCAL = 'local',
    E2E = 'e2e',
    DEVELOP = 'develop',
    STAGE = 'stage',
    PRELIVE = 'prelive',
    LIVE = 'live',
  }
}
